import React from 'react';
import './Navbar.scss';
import logo from './../../assets/logo.png';
import {Link} from 'react-router-dom';

const Navbar = () => {

    const navbarItems = [
        {
            name: 'Home',
            path: '/'
        },
        {
            name: 'About',
            path: '/about'
        },
        {
            name: 'Services',
            path: '/services',
            dropdown: [
                { name: 'General Dentistry', path: '/general-dentistry' },
                { name: 'Teeth Whitening', path: '/teeth-whitening' },
                { name: 'Root Canals', path: '/root-canals' },
                { name: 'Wisdom Teeth', path: '/wisdom-teeth' },
                { name: 'Veneers', path: '/veneers' },
                { name: 'Dental Implants', path: '/dental-implants' },
                { name: 'Crowns and Bridges', path: '/crowns-and-bridges' },
                { name: 'Invisalign', path: '/invisalign' },
                { name: 'Orthodontics', path: '/orthodontics' }
            ]
        },
        {
            name: 'Contact',
            path: '/contact'
        }
    ];

    return (
        <div className='main-nav'>
            <div className="container">
                <nav className="navbar navbar-expand-lg">
                    <div className="container-fluid">
                        {/* Logo */}
                        <Link className="navbar-brand" to="/">
                            <img src={logo} alt="logo" />
                        </Link>
                        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                        </button>
                        <div className="collapse navbar-collapse" id="navbarSupportedContent">
                            {/* Navbar Link */}
                            <ul className="navbar-nav m-auto mb-2 mb-lg-0">
                               { 
                                navbarItems.map((navSingle, index) =>
                                    navSingle.dropdown ? (
                                        <li key={index} className="nav-item dropdown">
                                            <Link className="nav-link dropdown-toggle" to={navSingle.path} id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                {navSingle.name}
                                            </Link>
                                            <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                                                {navSingle.dropdown.map((dropItem, dropIndex) => (
                                                    <li key={dropIndex}>
                                                        <Link className="dropdown-item" to={dropItem.path}>{dropItem.name}</Link>
                                                    </li>
                                                ))}
                                            </ul>
                                        </li>
                                    ) : (
                                        <li key={index} className="nav-item">
                                            <Link className="nav-link" to={navSingle.path}>{navSingle.name}</Link>
                                        </li>
                                    )
                                )}
                            </ul>
                            
                            {/* Navbar Button */}
                            <div className="theme-btn">
                                <Link to="/contact">Book appointment</Link>
                            </div>
                        </div>
                    </div>
                </nav>
            </div>
        </div>
    );
};

export default Navbar;
